import React from "react"
import { Box } from "@mui/material"
import { AppStatusPill } from "@components"


export default function statusColumn() {
	return {
		name: "status",
		render: value => <Box sx={{ display: 'flex', justifyContent: 'center' }}>
			<AppStatusPill status={value}/>
		</Box>
	}
}
